import styled from 'styled-components';

import { mobileFirstBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';

export const ImageWrapper = styled.div<{ $size: number }>`
    width: ${({ $size }) => `${$size}px`};
    height: ${({ $size }) => `${$size}px`};;
    flex-shrink: 0;

    img {
        display: block;
        height: 100%;
        width: 100%;
    }
`;

export const AppCard = styled.div`
    position: relative;

    & > div {
        &::before {
            content: '';
            width: 16px;
            height: 16px;
            position: absolute;
            left: -7px;
            bottom: 1px;
            background-image: url('/static/images/about/v2/apps/down-side.png');
            background-size: contain;
        }
    }

    & > div:last-of-type {
        display: none;
    }

    @media (min-width: ${mobileFirstBreakpoints.tablet}) {
        & div {
            pointer-events: none;
            transition: opacity 0.2s;
        }

        & > div:last-of-type {
            display: flex;
            opacity: 0;
            position: absolute;
        }

        &:hover > div:first-of-type {
            opacity: 0;
        }

        &:hover > div:last-of-type {
            opacity: 1;
        }
    }
`;
